// extracted by mini-css-extract-plugin
module.exports = {"container":"course_container__2wVrZ"};